import type {EditRepresentativeCommissionFormPayload} from "./edit-representative-commission.schema";

import {editRepresentativeCommission} from "@project/sdk/sales";
import {EditRepresentativeCommissionBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function editRepresentativeCommissionMutationOptions(
  representativeId: string,
  commissionId: number,
) {
  return mutationOptions({
    mutationFn: (payload: EditRepresentativeCommissionFormPayload) => {
      const request = EditRepresentativeCommissionBody.parse(payload);

      return editRepresentativeCommission(representativeId, commissionId, request);
    },
    mutationKey: representativeMutationKeys.editRepresentativeCommission,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
